import styled from 'styled-components';
import { Paper as PaperMUI } from '@mui/material';
import { shade } from 'polished';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  height: 100vh;

  display: flex;
  flex-direction: column;
`;

export const Route = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #888;
  padding: 8px 40px;
  margin-bottom: 40px;

  p {
    width: 100%;
    max-width: 1140px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 100%;

  > div {
    margin-top: 40px;
    p {
      text-align: center;
    }
  }
`;

export const SignInTitle = styled.p`
  color: #004e9a;
  font-weight: bold;
  text-align: center;
`;

export const Paper = styled(PaperMUI)`
  margin-top: 24px;
  width: 560px;
  padding: 48px 80px;
  margin-bottom: 40px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RecoverPasswordLink = styled(Link)`
  padding: 4px 0;
  color: #004e9a;
  font-weight: bold;
  text-decoration: none;

  &:hover {
    color: ${shade(0.2, '#004e9a')};
  }
`;

export const FormButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;

  button:first-child {
    margin-left: -8px;
  }
`;
